import { Select } from 'src/design-system/Select';
import type { TemplateWithoutSections } from 'src/data-capture/hooks/templates/useTemplates';

type Props = {
  templates: TemplateWithoutSections[];
  value: string | null;
  onChange: (templateId: string) => void;
  variant?: 'default' | 'card';
};

export function AgendaTemplateSelect({ templates, value, onChange, variant = 'default' }: Props) {
  if (templates.length <= 1) {
    return null;
  }

  return (
    <Select
      variant={variant}
      label="Agenda template"
      mb="sm"
      data={templates.map(template => ({ value: template.id, label: template.displayName }))}
      value={value}
      onChange={selected => selected && onChange(selected)}
      allowDeselect={false}
      comboboxProps={{ withinPortal: true }}
    />
  );
}
